import React from 'react';
import { Typography } from '@kiiwi/ui';

import { useSelector } from 'react-redux';
import { CardHcd } from '@maiia/model/generated/model/api-patient/api-patient';
import { get } from 'lodash';
import dayjs from 'dayjs';
import FontAwesomeIcon from '@/components/atoms/FontawesomeIcon/FontawesomeIcon';
import { Tag } from '@/components/ui/not-existing-kiiwi-components/Tag';
import { isDemoAccountSelector } from '@/src/selectors';
import { Trans, useTranslation } from '@/src/i18n';

interface Props {
  waitingVideoSessions: Array<any>;
  withTheSamePractitioner: boolean;
  item: Required<CardHcd>;
  onClick: React.ReactEventHandler;
}

const SearchCardTlcCTA = ({
  waitingVideoSessions,
  withTheSamePractitioner,
  item,
  onClick,
}: Props) => {
  const { t } = useTranslation();
  const isDemoAccount = useSelector(isDemoAccountSelector);
  const hasWaitingVideoSession: boolean = waitingVideoSessions?.length > 0;
  let couldDoTLC: boolean = !hasWaitingVideoSession || withTheSamePractitioner;
  if (isDemoAccount && couldDoTLC) couldDoTLC = item?.settings?.isDemo === true;
  const waitingRoomPatientNumber = item?.waitingRoomPatientNumber || 0;

  const minutesBeforeClosing = React.useMemo(() => {
    const closingTime = dayjs(
      get(item, 'settings.teleconsultationAvailabilityEndTime'),
    );
    const now = dayjs();
    const minutesDiff = closingTime.diff(now, 'minutes');
    if (minutesDiff >= 0 && minutesDiff <= 15) {
      if (minutesDiff <= 5) {
        return 5;
      }
      if (minutesDiff <= 10) {
        return 10;
      }
      if (minutesDiff <= 15) {
        return 15;
      }
    }
  }, [item]);

  return (
    <div
      className="flex w-full max-w-[121px] flex-1 cursor-pointer flex-col items-center justify-center rounded-sm bg-brand-secondary-hovered p-2 sm:max-w-[216px]"
      onClick={onClick}
    >
      <div className="flex h-8 w-8 items-center justify-center rounded-full bg-brand-primary-enabled">
        <FontAwesomeIcon name="video:solid" className="h-4 w-4 text-white" />
      </div>
      <Typography className="mt-1 text-base font-semibold text-brand-secondary-enabled sm:text-lg">
        {t('consult')}
      </Typography>
      {minutesBeforeClosing && (
        <Tag variant="warning" size="mobile" className="mt-1">
          <Trans
            i18nKey="closes-in-label"
            values={{ count: minutesBeforeClosing }}
          />
        </Tag>
      )}
      {waitingRoomPatientNumber > 0 && (
        <Typography
          variant="body-2"
          className="mt-1 text-xs text-brand-secondary-enabled sm:text-sm"
        >
          <Trans
            i18nKey="waiting-patient-count"
            values={{ count: waitingRoomPatientNumber }}
          />
        </Typography>
      )}
    </div>
  );
};

export default SearchCardTlcCTA;
